export { default } from './ContentTypeRichText';
